<template>
  <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
    <v-card-title>
      <div class="text-subtitle-1 font-weight-bold">Información general</div>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col>
            <v-text-field
              label="Evaluado"
              :value="getFullName(evaluacion.detalle.evaluado)"
              rounded
              filled
              dense
              color="secondary"
              background-color="primary"
              readonly
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              label="Evaluador"
              :value="getFullName(evaluacion.detalle.evaluador)"
              rounded
              filled
              dense
              color="secondary"
              background-color="primary"
              readonly
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              label="Municipio"
              :value="evaluacion.detalle.municipio.nombre"
              rounded
              filled
              dense
              color="secondary"
              background-color="primary"
              readonly
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              label="Fecha inicial"
              :value="evaluacion.detalle.fechaInicial"
              rounded
              filled
              dense
              color="secondary"
              background-color="primary"
              readonly
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              label="Fecha de conclusión"
              :value="evaluacion.detalle.fechaFin"
              rounded
              filled
              dense
              color="secondary"
              background-color="primary"
              readonly
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              label="Fecha de aplicación"
              :value="evaluacion.detalle.fechaAplicacion"
              rounded
              filled
              dense
              color="secondary"
              background-color="primary"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              label="Institución de seguridad pública a la que aplica"
              v-model="evaluacion.detalle.institucionSeguridadAspirada"
              rounded
              filled
              dense
              color="secondary"
              background-color="primary"
              readonly
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              label="Aspirante al puesto de"
              v-model="evaluacion.detalle.puestoAspirado"
              rounded
              filled
              dense
              color="secondary"
              background-color="primary"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    evaluacion: {
      type: Object,
      required: true,
    },
  },
}
</script>
